/**
 * Clipboard helper — modern API only (`navigator.clipboard.writeText`), no
 * `document.execCommand` fallback (spec.md § Editor / Clipboard, last-1
 * evergreen browser support). Returns a boolean so callers can decide whether
 * to show a success or failure toast without try/catch noise at the call site.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
